import React, { useEffect, useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import UsersSelect from '../users-select/users-select.component';
import moment from 'moment';
import { TableContainer, Header, HeaderButtons, Title, TableHeader, TableBody } from './table.styles';

const dateRanges = [
  'Today',
  'Last 7 Days',
  'Last 30 Days',
  'This Month',
  'Last Month',
];

const TableComponent = ({
  title,
  headerButtons,
  onSearch,
  onUsersSelect,
  isUsersSelectArray = true,
  usersSelectDefaultValue = [],
  onDateRangeChange,
  showAmount,
  amount = {},
  amountTooltip,
  nextToTitle,
  headerItems = [],
  children,
  onEdge,
  isLoading,
}) => {
  const [selectedDateRangeText, setSelectedDateRangeText] = useState('Select date range');
  const [scrollPosition, setScrollPosition] = useState(0);

  const bodyRef = useRef();
  const { current: body } = bodyRef;

  useEffect(() => {
    if (body && onEdge) {
      if (body.scrollHeight - scrollPosition === body.clientHeight) {
        onEdge();
      }
    }
  }, [scrollPosition, body]);

  return (
    <TableContainer>
      <Header>
        <Title>{title}{showAmount && (!amountTooltip ? 
          <Badge bg="secondary" size="sm">{amount}</Badge>
          :
          <OverlayTrigger placement='right' overlay={
            <Tooltip id="tooltip-amount"><span>{amountTooltip}</span></Tooltip>
          }>
            <Badge bg="secondary" size="sm" style={{ cursor: 'pointer' }}>{amount}</Badge>
          </OverlayTrigger>)}
          <h6>{nextToTitle}</h6>
        </Title>
        <HeaderButtons>
          {onDateRangeChange && <DateRangePicker initialSettings={{
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            ranges: {
              'Today': [new Date(), new Date()],
              'Last 7 Days': [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
              'Last 30 Days': [new Date(new Date().setDate(new Date().getDate() - 30)), new Date()],
              'This Month': [moment().startOf('month').format('MM/DD/YYYY'), moment().endOf('month').format('MM/DD/YYYY')],
              'Last Month': [moment().subtract(1, 'month').startOf('month').format('MM/DD/YYYY'), moment().subtract(1, 'month').endOf('month').format('MM/DD/YYYY')],
            }
          }}
          onCallback={(start, end, label) => {
            setSelectedDateRangeText(dateRanges.includes(label) ? label : `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`);
            onDateRangeChange(start, end, label);
          }}>
            <Button variant="primary" style={{ whiteSpace: 'nowrap' }}>{selectedDateRangeText}</Button>
          </DateRangePicker>}
          {onSearch && <Form.Control type="text" placeholder="Search" onChange={(e) => onSearch(e.target.value)} />}
          {headerButtons}
        </HeaderButtons>
      </Header>

      {onUsersSelect && <UsersSelect 
        placeholder={'User'}
        multiple={isUsersSelectArray}
        onChange={onUsersSelect}
        defaultValue={usersSelectDefaultValue ? isUsersSelectArray ? usersSelectDefaultValue : [usersSelectDefaultValue] : null}
      />}

      <div>
        <TableHeader>
          {headerItems.map(({ label, style = {} }, index) => (<span key={index} style={style}>{label}</span>))}
        </TableHeader>
        <hr style={{ margin: '0.5rem', marginTop: '0', border: '1px solid #3c3c3c', opacity: '1' }} />
        <TableBody
          ref={bodyRef}
          onScroll={(e) => setScrollPosition(e.target.scrollTop)}
        >
          {children}
          {isLoading && <>loading...</>}
        </TableBody>
      </div>
    </TableContainer>
  );
};

export default TableComponent;
